<div
  *ngFor="let item of items"
  class="ui-kpi-row__item"
  [ngClass]="'ui-kpi-row__item--' + (item.tone || 'default')"
  [title]="item.hint || ''"
>
  <p class="ui-kpi-row__label">{{ item.label }}</p>
  <p class="ui-kpi-row__value">{{ item.value }}</p>
  <p class="ui-kpi-row__hint" *ngIf="item.hint">{{ item.hint }}</p>
</div>
